import React, { Component } from 'react';
class Cta extends Component {
  render() {
    const {
      title,
      buttonText,
      ctaPosition,
      ctaMobilePosition,
      link,
      links,
      description,
      titleFontSize
    } = this.props;

    return (
      <div
        className={`${link ? 'cta' : ''} text ${ctaPosition ||
          'right-center'} ${ctaMobilePosition || 'right-center-mobile'}`}
      >
        {title && (
          <div className={`text-title ${titleFontSize ? titleFontSize : ''}`}>
            {title}
          </div>
        )}
        {description && <p>{description}</p>}
        {links && links.length > 0 ? (
          <ul>
            {links.map(link => (
              <li>
                <a
                  href={`${link.url}${link.tag ? link.tag : ''}`}
                  title={link.text}
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <React.Fragment>
            {buttonText && (
              <div className="btn btn-outline-primary" title={title}>
                <span>{buttonText}</span>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Cta;



// WEBPACK FOOTER //
// ./src/components/landingPage/Cta/Cta.js